module.exports = __webpack_public_path__ + "img/dr_13.dcfac39d.png";